(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./index.less", "../tab-bar/index", "../sticky/index", "../_mixins/tabBar"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./index.less"), require("../tab-bar/index"), require("../sticky/index"), require("../_mixins/tabBar"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.index, global.index, global.index, global.tabBar);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _index, _index2, _index3, _tabBar) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _index2 = _interopRequireDefault(_index2);
  _index3 = _interopRequireDefault(_index3);
  _tabBar = _interopRequireDefault(_tabBar);

  var _components;

  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        staticClass: "nx-tabs"
      }, [_vm.sticky ? [_c('nx-sticky', {
        ref: "sticky",
        attrs: {
          "offset": _vm.offset,
          "boundary": _vm.boundary
        },
        on: {
          "onScroll": _vm.handleScroll
        }
      }, [_c('nx-tab-bar', {
        ref: "tabBar",
        attrs: {
          "items": _vm.menus,
          "immediateAnimation": _vm.immediateAnimation,
          "bottomBorder": true,
          "value": _vm.currentName,
          "has-ink": _vm.hasInk,
          "ink-length": _vm.inkLength,
          "blurMaterial": _vm.blurMaterial,
          "immediate": _vm.immediate,
          "tabBarType": _vm.tabBarType,
          "ink-color": _vm.inkColor,
          "tabBarStyle": _vm.tabBarStyleData
        },
        on: {
          "change": _vm.$_handleTabClick,
          "changeTabBarHeight": _vm.changeTabBarHeight
        }
      })], 1)] : [_c('nx-tab-bar', {
        ref: "tabBar",
        attrs: {
          "items": _vm.menus,
          "immediateAnimation": _vm.immediateAnimation,
          "bottomBorder": true,
          "value": _vm.currentName,
          "blurMaterial": _vm.blurMaterial,
          "has-ink": _vm.hasInk,
          "ink-length": _vm.inkLength,
          "immediate": _vm.immediate,
          "tabBarType": _vm.tabBarType,
          "ink-color": _vm.inkColor,
          "tabBarStyle": _vm.tabBarStyleData
        },
        on: {
          "change": _vm.$_handleTabClick,
          "changeTabBarHeight": _vm.changeTabBarHeight
        }
      })], _c('div', {
        staticClass: "nx-tabs-content"
      }, [_vm._t("default")], 2)], 2);
    },
    name: 'nx-tabs',
    components: (_components = {}, (0, _defineProperty2.default)(_components, _index2.default.name, _index2.default), (0, _defineProperty2.default)(_components, _index3.default.name, _index3.default), _components),
    props: {
      value: String,
      hasInk: {
        type: Boolean,
        default: true
      },
      inkLength: Number,
      immediate: Boolean,
      sticky: {
        type: Boolean,
        default: false
      },
      offset: {
        type: Number,
        default: 0
      },
      boundary: {
        type: String,
        default: ''
      },
      tabBarType: {
        type: String,
        default: 'fixed'
      },
      immediateAnimation: {
        type: Boolean,
        default: true
      },
      isPrevent: {
        type: Boolean,
        default: true
      },
      blurMaterial: {
        type: Boolean,
        default: false
      }
    },
    mixins: [_tabBar.default],
    data: function data() {
      return {
        currentName: this.value,
        prevIndex: 0,
        panes: []
      };
    },
    watch: {
      value: function value(val) {
        if (val !== this.currentName) {
          this.currentName = val;
        }
      }
    },
    computed: {
      menus: function menus() {
        return this.panes.map(function (pane) {
          return {
            name: pane.name,
            label: pane.label,
            disabled: pane.disabled
          };
        });
      },
      currentIndex: function currentIndex() {
        for (var i = 0, len = this.menus.length; i < len; i++) {
          if (this.menus[i].name === this.currentName) {
            return i;
          }
        }

        return 0;
      }
    },
    provide: function provide() {
      return {
        rootTabs: this
      };
    },
    mounted: function mounted() {
      if (!this.currentName && this.menus.length) {
        this.currentName = this.menus[0].name;
      }
    },
    methods: {
      // MARK: private events
      $_handleTabClick: function $_handleTabClick() {
        var _this$panes$index;

        var tab = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var index = arguments.length > 1 ? arguments[1] : undefined;
        var prevIndex = arguments.length > 2 ? arguments[2] : undefined;
        this.currentName = tab.name || ((_this$panes$index = this.panes[index]) === null || _this$panes$index === void 0 ? void 0 : _this$panes$index.name);
        this.prevIndex = prevIndex;
        this.$emit('input', tab.name);
        this.$emit('change', tab);
      },
      // MARK: private methods
      $_addPane: function $_addPane(pane) {
        if (this.panes.indexOf(pane) === -1) {
          this.panes.push(pane);
        }
      },
      $_removePane: function $_removePane(pane) {
        var index = this.panes.indexOf(pane);

        if (index >= 0) {
          this.panes.splice(index, 1);
        }
      },
      handleScroll: function handleScroll(scrollTop, affixed) {
        this.tabBarStyleData = affixed ? this.tabBarStyleAffixed : this.tabBarStyle;
      },
      reflowTabBar: function reflowTabBar() {
        this.$refs.tabBar.reflow();
      },
      changeTabBarHeight: function changeTabBarHeight() {
        var _this$$refs$sticky;

        (_this$$refs$sticky = this.$refs.sticky) === null || _this$$refs$sticky === void 0 ? void 0 : _this$$refs$sticky.reflow();
      }
    }
  };
  _exports.default = _default;
});